<template>
    <menu
      class="nav-menu"
      :title="menu.title || ' '"
      :class="{ 'is-dark': dark, 'is-secondary': secondary }"
    >
      <div class="menu-list">
        <template v-for="(item) in menu.menuItems">
          <div class="ps-icon nav-menu-item-icon" v-if="item.usePsIcon">
            <img :src="psIconURL" :alt="item.title">
          </div>
          <figure class="item-avatar image is-32x32" v-else-if="item.imageUrl">
            <img :src="item.imageUrl" :alt="item.title" class="squircle">
          </figure>
          <NavMenuItem :item="item"
                       v-else
          />
        </template>
      </div>
    </menu>
</template>

<script setup lang="ts">

  import { ref, toRefs } from "vue";
  import {type RouteLocationNormalized, useRoute, useRouter} from "vue-router";

  import NavMenuItem from '@/components/NavMenuItem.vue';
  import {storeToRefs} from 'pinia';
  import {useClientStore} from '@/stores/ClientStore';

  import {
    Menu,
  } from '@/internal';

  let numUnreadNotifications = ref(0);
  const currentRoute = useRoute();
  const router = useRouter();

  const {psIconURL} = storeToRefs(useClientStore());

  const props = withDefaults(defineProps<{
    dark?: boolean,
    menu: Menu,
    secondary?: boolean,
  }>(), {
    dark: false,
    secondary: false,
  });
  const {
    dark,
    menu,
    secondary,
  } = toRefs(props);

  function handleMenuItem(route: RouteLocationNormalized) {
    router.push({
      name: route.name || undefined,
    });
  }

</script>

<style lang="scss">

    .nav-menu {
        background: var(--nav-background);
        color: var(--nav-text);
        padding: 25px 0;

        li {
          list-style-type: none;
        }

        .menu-item {
          margin-top: 3px;
          margin-bottom: 3px;
          display: flex;
          align-items: center;
          color: var(--nav-text);

          &:hover {
            border-radius: 5px;
            background-color: var(--nav-background-hover);
          }

          .icon {
            line-height: 1em;
          }

          span:nth-child(2) {
            vertical-align: top;
            margin-left: .3em;
          }

          &.item-active,
          &:hover:not(.has-ps-icon):not(.has-image),
          &.router-link-exact-active:not(.has-ps-icon):not(.has-image) {
            background: var(--nav-background-active);
            color:var(--nav-text);
            border-radius: 5px;

            &:hover:not(.has-ps-icon):not(.has-image) {
              background: var(--nav-background-hover);
              color:var(--nav-text);
            }
          }

          &.icon-only {
            height: 48px;
            align-items: center;
            border-radius: 50%;

            &:active,
            &.item-active,
            &:hover:not(.has-ps-icon):not(.has-image),
            &.router-link-exact-active:not(.has-ps-icon):not(.has-image) {
              background: var(--nav-background-hover);
              color:var(--nav-text);
            }
          }

        }

        .nav-menu-item {
          padding: 0;

          &.has-ps-icon {
            margin-bottom: 10px;
          }

          &.has-ps-icon:hover,
          &.has-image:hover {
            background-color: transparent;
          }

        }

        .item-active {
          //border-radius: 50%;
          //background: $primary-dark;
          //color: $white;
        }

        .sub-menu {
          border-left: 1px solid var(--nav-secondary-border-color);
          margin-left: 1em;
          margin-top: 0;
          padding-left: .5em;
        }

      .nav-menu-item-icon {
        align-items: center;
        display: flex;
        justify-content: center;

        &.ps-icon {

          margin-bottom: 1em;

          img {
            left: 2.5px;
            position: relative;
            width: 24px;
          }
        }

        .icon {
          line-height: 1em;

          i {
            position: relative;
            top: 1px;
          }
        }
      }

      &.is-secondary{
        background: var(--nav-secondary-background);
        color: var(--nav-secondary-text);

        .menu-item {
          color: var(--nav-secondary-text);

          &:hover {
            background-color: var(--nav-secondary-background-hover);
          }

          &.item-active,
          &:hover:not(.has-ps-icon):not(.has-image),
          &.router-link-exact-active:not(.has-ps-icon):not(.has-image) {
            background: var(--nav-secondary-background-active);
            color: var(--nav-secondary-text);

            &:hover:not(.has-ps-icon):not(.has-image) {
              background: var(--nav-secondary-background-hover);
              color:var(--nav-secondary-text);
            }
          }

          &.icon-only {
            &:active,
            &.item-active,
            &:hover:not(.has-ps-icon):not(.has-image),
            &.router-link-exact-active:not(.has-ps-icon):not(.has-image) {
              background: var(--nav-secondary-background-hover);
              color:var(--nav-secondary-text);
            }
          }

        }

        .nav-menu-item {
          &.has-ps-icon:hover,
          &.has-image:hover {
            background-color: transparent;
          }

        }

        .item-active {
          //background: $primary-dark;
          //color: $white;
        }

        .sub-menu {
          border-left-color: var(--nav-secondary-border-color);
        }
      }
    }
</style>
